
export default {
  baseUrlMicrofrontend:'https://app.auth.surepoint.cloud',
  ssoApiBaseUrl:'https://apiv2.auth.surepoint.cloud',
  addInDomainUrl: "https://addin.auth.surepoint.cloud",
   ICON_BASE_URL : "https://frontend-icon-store-prod.s3.us-east-2.amazonaws.com/fe-sso/prod/public/"
};

export const env_name = "prod" 